export default __webpack_public_path__ + "static/media/Bootcamp.fbf068a6.png";